// documentReferenceSlice.js
import { createSlice } from "@reduxjs/toolkit";

const documentReferenceSlice = createSlice({
    name: "documentReferences",
    initialState: {},
    reducers: {
        registerDocumentReference: (state, action) => {
            const doc = action.payload;
            if (!doc?.id) return;

            if (!state[doc.id]) {
                state[doc.id] = doc;
            } else {
                console.warn(
                    `⚠️ DocumentReference ${doc.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterDocumentReferences: (state, action) => {
            action.payload.forEach((doc) => {
                if (!doc?.id) return;

                if (!state[doc.id]) {
                    state[doc.id] = doc;
                } else {
                    console.warn(
                        `⚠️ DocumentReference ${doc.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerDocumentReference,
    bulkRegisterDocumentReferences
} = documentReferenceSlice.actions;

export default documentReferenceSlice.reducer;
